module.exports = __webpack_public_path__ + "static/brainlink-4bdd466afde6fa3588dbed22962a289a.jpg";